import { createScanner } from "./scanner";
import { parseExpression } from "./parser";
import { calculateAst } from "./calculator";
export { MAX_NUMBER } from "./consts";
export function parse(str) {
    var strNoLineBreaks = str.replace(/\r|\n/g, " ");
    var scanner = createScanner(strNoLineBreaks);
    var ast = parseExpression(scanner);
    // console.info(JSON.stringify(ast, null, 4));
    return ast;
}
export function calculate(str, params, random) {
    if (params === void 0) { params = []; }
    var ast = parse(str);
    var value = calculateAst(ast, params, random);
    return Math.round(value);
}
//console.info(parse('2 +  2 * 2 +2+2'))
//console.info(parse('2 + 2 * 2 + 2'))
//console.info(parse("2 in 2 to 3"));
// console.info(parse("[-2]"));
//console.info(parse("[-3;-3;-3..-3]"));
//console.info(parse("3 + [1;3;6..9] - 3"));
//console.info(parse("[p11]-[5..30]*0,4"));
//console.info(parse('[p1] div1000000mod 10',[12346789]))
//console.info(parse('10 000'));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sV0FBVyxDQUFDO0FBQzFDLE9BQU8sRUFBRSxlQUFlLEVBQUUsTUFBTSxVQUFVLENBQUM7QUFDM0MsT0FBTyxFQUFFLFlBQVksRUFBRSxNQUFNLGNBQWMsQ0FBQztBQUc1QyxPQUFPLEVBQUUsVUFBVSxFQUFFLE1BQU0sVUFBVSxDQUFDO0FBRXRDLE1BQU0sVUFBVSxLQUFLLENBQUMsR0FBVztJQUMvQixJQUFNLGVBQWUsR0FBRyxHQUFHLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxHQUFHLENBQUMsQ0FBQztJQUNuRCxJQUFNLE9BQU8sR0FBRyxhQUFhLENBQUMsZUFBZSxDQUFDLENBQUM7SUFDL0MsSUFBTSxHQUFHLEdBQUcsZUFBZSxDQUFDLE9BQU8sQ0FBQyxDQUFDO0lBQ3JDLDhDQUE4QztJQUM5QyxPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUM7QUFDRCxNQUFNLFVBQVUsU0FBUyxDQUFDLEdBQVcsRUFBRSxNQUF3QixFQUFFLE1BQWtCO0lBQTVDLHVCQUFBLEVBQUEsV0FBd0I7SUFDN0QsSUFBTSxHQUFHLEdBQUcsS0FBSyxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ3ZCLElBQU0sS0FBSyxHQUFHLFlBQVksQ0FBQyxHQUFHLEVBQUUsTUFBTSxFQUFFLE1BQU0sQ0FBQyxDQUFDO0lBQ2hELE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUMzQixDQUFDO0FBRUQsd0NBQXdDO0FBQ3hDLHNDQUFzQztBQUN0QyxxQ0FBcUM7QUFFckMsK0JBQStCO0FBQy9CLHdDQUF3QztBQUN4Qyw0Q0FBNEM7QUFDNUMsMkNBQTJDO0FBRTNDLHlEQUF5RDtBQUN6RCxnQ0FBZ0MifQ==